<h1 class="pb-2">{{ 'REPORTS.title' | translate: { count: 0 } }}</h1>
@if (reportListData[0]?.product_subscriptions_count === 0) {
  @if(currentLanguage === 'en'){
    <p class="pb-5">This product does not yet have any users registered to receive the monthly report by email.</p>
  } @else {
    <p class="pb-5">Für dieses Produkt sind noch keine Nutzer registriert, die den Monatsbericht per E-Mail erhalten möchten.</p>
  }

} @else {
  @if(currentLanguage === 'en'){
    <p class="pb-5">To receive the monthly report by email,
      {{reportListData[0]?.product_subscriptions_count}} users have subscribed.</p>
  } @else {
    <p class="pb-5">Für den Erhalt des monatlichen Berichts per E-Mail haben sich
      {{reportListData[0]?.product_subscriptions_count}} Nutzer angemeldet.</p>
  }

}

<app-cards-basic title="{{ 'REPORTS.list' | translate:{ count: 0 } }}" [loading]="isLoading">

  @defer {
    <mat-list role="list">
        @for(report of reportListData; track report){
          <ng-container>
            <mat-list-item class="list-border-bottom">
              {{ report.translations[currentLanguage].title }} – {{ report.date }}<br>

              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="More" class="trailing-end-button">
                <mat-icon>
                  <span class="material-symbols-outlined">more_vert</span>
                </mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                @if(report.translations['en'].pdf_file) {
                  <button mat-menu-item  (click)="openPdf(report, 'en', $event)">
                    <mat-icon>
                      <span class="material-symbols-outlined">download</span>
                    </mat-icon>
                    Download PDF (EN)
                  </button>
                }
                @if(report.translations['de'].pdf_file) {
                  <button mat-menu-item  (click)="openPdf(report, 'de', $event)">
                    <mat-icon>
                      <span class="material-symbols-outlined">download</span>
                    </mat-icon>
                    Download PDF (DE)
                  </button>
                }

                <button mat-menu-item  (click)="generatePdfForPage(report, $event)">
                  <mat-icon>
                    <span class="material-symbols-outlined">picture_as_pdf</span>
                  </mat-icon>
                  Generate Repord PDF's
                </button>
                @if(report.translations['en'].pdf_file || report.translations['de'].pdf_file) {
                  @if(report.product_subscriptions_count > 0){
                    <button mat-menu-item (click)="sendReport(report, $event)">
                      <mat-icon>
                        <span class="material-symbols-outlined">send</span>
                      </mat-icon>
                      Send to {{report.product_subscriptions_count}} Subscribers
                    </button>
                  }

                }

                <button mat-menu-item (click)="editReport(report)">
                  <mat-icon>
                    <span class="material-symbols-outlined">edit</span>
                  </mat-icon>
                  Edit Report
                </button>
                <button mat-menu-item (click)="confirmDelete(report.id, $event)">
                  <mat-icon>
                    <span class="material-symbols-outlined">delete</span>
                  </mat-icon>
                  Delete Report
                </button>
              </mat-menu>


            </mat-list-item>
          </ng-container>
        }
    </mat-list>

    @if (!isFormVisible) {
      <button mat-flat-button
              color="primary"
              (click)="toggleFormVisibility()"
              class="mt-3 bp-button">
        {{ 'REPORTS.create' | translate }}
      </button>
    }

  } @loading (minimum 800ms) {
    <mat-spinner diameter="30" strokeWidth="1" style="margin:0 auto;"></mat-spinner>
  }
</app-cards-basic>

@if (isFormVisible) {
<app-cards-basic title="Report Form">
    <form #periodForm="ngForm" (ngSubmit)="savePhase()" class="pt-3">
      <div class="row">
        <mat-form-field appearance="fill" class="col">
          <mat-label>{{ 'COMMON.title_en' | translate }}</mat-label>
          <input matInput
                 required
                 [(ngModel)]="reportItem.translations['en'].title"
                 name="ReportTitelEn">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="fill" class="col">
          <mat-label>{{ 'COMMON.title_de' | translate }}</mat-label>
          <input matInput
                 required
                 [(ngModel)]="reportItem.translations['de'].title"
                 name="ReportTitelDe">
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="fill" class="col">
          <mat-label>{{ 'COMMON.date' | translate: {count: 1} }}</mat-label>
          <input matInput [matDatepicker]="startDatePicker"
                 required
                 [(ngModel)]="reportItem.date"
                 name="date">
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="fill" class="col">
          <mat-label>{{ 'COMMON.comment' | translate: {count: 1} }} ({{ 'COMMON.english' | translate }}) (max. 1100 Char)</mat-label>
          <textarea matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="2"
                    cdkAutosizeMaxRows="10"
                    maxlength="1100"
                    [(ngModel)]="reportItem.translations['en'].comment"
                    name="commentDe"></textarea>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="fill" class="col">
          <mat-label>{{ 'COMMON.comment' | translate: {count: 1} }} ({{ 'COMMON.german' | translate }}) (max. 1100 Char)</mat-label>
          <textarea matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="2"
                    cdkAutosizeMaxRows="10"
                    maxlength="1100"
                    [(ngModel)]="reportItem.translations['de'].comment"
                    name="commentDe"></textarea>
        </mat-form-field>
      </div>

      <div class="row py-4">
        <div class="col">
          <h3 class="pt-4">Template</h3>
          <mat-radio-group
            aria-labelledby="example-radio-group-label"
            class="example-radio-group"
            [value]="selectedPage"
            (change)="onSelectedPageChange($event.value)">
            @for (page of pageList; track page) {
              <mat-radio-button class="example-radio-button"
                                [value]="page">
                {{page.translations[currentLanguage].title}}
              </mat-radio-button>
              <br>
            }
          </mat-radio-group>
        </div>
      </div>
      <button mat-flat-button
              color="primary"
              type="submit"
              class="bp-button"
              [disabled]="!periodForm.valid" >
        {{ 'ACTIONS.save' | translate }}
      </button>
      <button mat-flat-button
              type="button"
              class="bp-button"
              (click)="toggleFormVisibility()">
        {{ 'ACTIONS.cancel' | translate }}
      </button>
    </form>
</app-cards-basic>
}
